import React from 'react';
import styles from './figure.module.scss';

const Caption = ({ color, className = '', text }) => {
    return (
        <figcaption
            className={`position-absolute text-center text-uppercase text-inter-heavy w-100 py-1 size-oslo ${styles[color]} ${className}`}
            style={{ bottom: 0, right: 0 }}>
            {text}
        </figcaption>
    );
};

export const Figure = ({
    className = '',
    imageUrl,
    title,
    captionText,
    captionColor
}) => {
    return (
        <figure
            className={`position-relative border mb-0 ${styles.figure} ${className}`}>
            <img className="w-100" src={imageUrl} alt={title} />
            <Caption text={captionText} color={captionColor} />
        </figure>
    );
};
